import app from './app';
import chat from './chat';
import user from './user';
import consults from './consults';
import info from './info';
import prescription from './prescription';
import videoCall from './video-call';
import iciciQueue from './iciciQueue';
import bajajQueue from './bajajQueue';
import aegonQueue from './aegonQueue';
import licQueue from './licQueue';
import autoDialOps from './autoDialOps';
import agentRoster from './agentRoster';

export default {
  app,
  chat,
  consults,
  user,
  info,
  prescription,
  videoCall,
  iciciQueue,
  bajajQueue,
  aegonQueue,
  licQueue,
  autoDialOps,
  agentRoster,
};
